import {TabsTemplate} from 'components/Common/Tabs/Template';
import {withProps} from 'recompose';

export default withProps({
  tabs: {
    index: '會員列表',
  },
  title: '捷克會員管理',
})(TabsTemplate);
